import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit
} from '@angular/core';import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';
import { MenuItems } from '../../shared/menu-items/menu-items';/** @title Responsive sidenav */
import { CommonService } from '../../shared/common.service';
import { ProfileService } from '../../main/myprofile/myprofile.service';
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.scss']
})
export class FullComponent implements OnDestroy, AfterViewInit {

  mobileQuery: MediaQueryList;
  isMenuOpen = true;
  contentMargin: number ;

  events: string[] = [];
  opened: boolean;
  showMenuAdmin = false;
  showMenuContest = false;
  showMenuAnalytic= false;
  profileDetail:any;

  shouldRun = [/(^|\.)plnkr\.co$/, /(^|\.)stackblitz\.io$/].some(h => h.test(window.location.host));

  toggleMenuAdmin() {
     this.showMenuAdmin = !this.showMenuAdmin;
  }
  toggleMenuContest() {
    this.showMenuContest = !this.showMenuContest;
 }
 toggleMenuAnalytic() {
  this.showMenuAnalytic = !this.showMenuAnalytic;
}

 logoutUser() { 
  this.commonService.logOut();
}
getProfile() {
  this.adminService.getProfile().subscribe (
    res => {
    if ((res["message"] = "Success")) {
      this.profileDetail = res["data"]
      this.commonService.setStorage('userData', JSON.stringify(this.profileDetail));
    } else {
  
    }      },
    err => {
   
    }
  );
}

  private _mobileQueryListener: () => void;  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private commonService: CommonService,
    private adminService:ProfileService,
  ) {
    this.getProfile(); 
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    console.log('mobileQuery',this.mobileQuery)
  }  WindowResize(e) {
    setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 260);
    }  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }  onToolbarMenuToggle() {
    console.log('On toolbar toggled', this.isMenuOpen);
    this.isMenuOpen = !this.isMenuOpen;
    console.log('isMenuOpen',this.isMenuOpen) 
       if(!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }
  ngAfterViewInit() {

  }
}


